import {translate} from '@docusaurus/Translate';

export type SearchGroup = 'guides' | 'endpoints' | 'events';

export type SearchCatalogItem = {
  group: SearchGroup;
  label: string;
  description: string;
  to: string;
  keywords: string;
};

export function getSearchCatalog(): SearchCatalogItem[] {
  return [
    {
      group: 'guides',
      label: translate({id: 'search.guide.quickstart', message: 'Início rápido'}),
      description: translate({id: 'search.guide.quickstart.description', message: 'De QA à primeira cobrança em poucos minutos.'}),
      to: '/docs/start/quickstart',
      keywords: 'começar QA integração credencial',
    },
    {
      group: 'guides',
      label: translate({id: 'search.guide.pix', message: 'Receber com PIX'}),
      description: translate({id: 'search.guide.pix.description', message: 'Cobrança, QR Code e confirmação de pagamento.'}),
      to: '/docs/payments/pix',
      keywords: 'pix qr code cobrança pagamento',
    },
    {
      group: 'guides',
      label: 'Checkout',
      description: translate({id: 'search.guide.checkout.description', message: 'Sessões de checkout e métodos de pagamento.'}),
      to: '/docs/payments/checkout',
      keywords: 'checkout sessão carrinho pagamento',
    },
    {
      group: 'guides',
      label: translate({id: 'search.guide.subscriptions', message: 'Assinaturas'}),
      description: translate({id: 'search.guide.subscriptions.description', message: 'Planos, recorrência e ciclo de vida.'}),
      to: '/docs/subscriptions/overview',
      keywords: 'assinatura plano recorrência cobrança',
    },
    {
      group: 'guides',
      label: translate({id: 'search.guide.affiliates', message: 'Afiliados e split'}),
      description: translate({id: 'search.guide.affiliates.description', message: 'Divisão de receita, comissões e repasses.'}),
      to: '/docs/finance/affiliates-and-payouts',
      keywords: 'afiliado split comissão repasse saldo',
    },
    {
      group: 'guides',
      label: 'Webhooks',
      description: translate({id: 'search.guide.webhooks.description', message: 'Assinatura, tentativas e processamento seguro.'}),
      to: '/docs/webhooks/overview',
      keywords: 'webhook assinatura retry evento',
    },
    {
      group: 'endpoints',
      label: 'POST /v1/charges',
      description: translate({id: 'search.endpoint.charge', message: 'Criar cobrança PIX ou cartão B2B direto.'}),
      to: '/docs/api-reference/public/create-charge',
      keywords: 'endpoint api cobrança charge pix cartão',
    },
    {
      group: 'endpoints',
      label: 'POST /v1/customers',
      description: translate({id: 'search.endpoint.customer', message: 'Criar cliente.'}),
      to: '/docs/api-reference/public/create-customer',
      keywords: 'endpoint api cliente customer',
    },
    {
      group: 'endpoints',
      label: 'POST /v1/products',
      description: translate({id: 'search.endpoint.product', message: 'Criar produto no catálogo.'}),
      to: '/docs/api-reference/public/create-product',
      keywords: 'endpoint api produto catálogo',
    },
    {
      group: 'endpoints',
      label: 'POST /v1/checkout-sessions',
      description: translate({id: 'search.endpoint.checkout', message: 'Criar sessão de checkout.'}),
      to: '/docs/api-reference/public/create-checkout-session',
      keywords: 'endpoint api checkout sessão',
    },
    {
      group: 'endpoints',
      label: 'POST /v1/subscriptions',
      description: translate({id: 'search.endpoint.subscription', message: 'Criar assinatura recorrente.'}),
      to: '/docs/api-reference/public/create-subscription',
      keywords: 'endpoint api assinatura subscription recorrência',
    },
    {
      group: 'events',
      label: 'charge.paid',
      description: translate({id: 'search.event.chargePaid', message: 'Cobrança confirmada como paga.'}),
      to: '/docs/webhooks/event-catalog',
      keywords: 'evento webhook cobrança paga charge paid',
    },
    {
      group: 'events',
      label: 'checkout_session.paid',
      description: translate({id: 'search.event.checkoutPaid', message: 'Checkout concluído com pagamento.'}),
      to: '/docs/webhooks/event-catalog',
      keywords: 'evento webhook checkout pago',
    },
    {
      group: 'events',
      label: 'subscription.payment_failed',
      description: translate({id: 'search.event.subscriptionFailed', message: 'Pagamento recorrente não concluído.'}),
      to: '/docs/webhooks/event-catalog',
      keywords: 'evento webhook assinatura falhou pagamento',
    },
  ];
}
